const STORY_MODE_KEY = "stories:mode";
const SHOW_AUDIO_PLAYER_KEY = "stories:showAudioPlayer";
const OPENED_TIMES_KEY = "stories:openedTimes";
const VOICE_ID_KEY = "stories:voiceId";

const read = (key, fallback) => {
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : JSON.parse(value);
  } catch {
    return fallback;
  }
};

const write = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {}
};

export const getStoryMode = () => read(STORY_MODE_KEY, "smart");
export const saveStoryMode = (mode) => write(STORY_MODE_KEY, mode);

export const getShowStoryAudioPlayer = () => read(SHOW_AUDIO_PLAYER_KEY, true);
export const saveShowStoryAudioPlayer = (isShown) => write(SHOW_AUDIO_PLAYER_KEY, isShown);

export const getStoryOpenedTimes = () => read(OPENED_TIMES_KEY, {});
export const saveStoryOpened = (key) => write(OPENED_TIMES_KEY, { ...getStoryOpenedTimes(), [key]: Date.now() });

export const getStoryVoiceId = () => read(VOICE_ID_KEY, null);
export const saveStoryVoiceId = (voiceId) => write(VOICE_ID_KEY, voiceId);
